import { makeStyles } from '@material-ui/core/styles';

const useSectionStyles = makeStyles(theme => ({
  manualAutofinalization: {
    padding:'1em',
    border: 'solid 1px black',
    '& div, h5': {
      marginBottom:'4px'
    },
    marginBottom:'8px'
  },
  encounterProcessing: {
    padding:'1em',
    border: 'solid 1px black',
    '& div': {
      marginBottom:'2px'
    },
    marginBottom:'8px'
  },
  audit: {
    padding:'1em',
    border: 'solid 1px black',
    '& div': {
      marginBottom:'2px'
    },
    marginBottom:'8px'
  },
  priority: {
    padding:'1em',
    border: 'solid 1px black',
    '& div': {
      marginBottom:'2px'
    },
    marginBottom:'8px'
  }
}));

export default useSectionStyles;
